import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import StockMarketFundamentals from './pages/StockMarketFundamentals';
import InvestmentBasics from './pages/InvestmentBasics';
import TradingPrinciples from './pages/TradingPrinciples';
import RiskManagement from './pages/RiskManagement';
import MarketAnalysis from './pages/MarketAnalysis';
import Glossary from './pages/Glossary';
import Quiz from './pages/Quiz';
import TradingPlatforms from './pages/TradingPlatforms';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/stock-market-fundamentals" element={<StockMarketFundamentals />} />
            <Route path="/investment-basics" element={<InvestmentBasics />} />
            <Route path="/trading-principles" element={<TradingPrinciples />} />
            <Route path="/risk-management" element={<RiskManagement />} />
            <Route path="/market-analysis" element={<MarketAnalysis />} />
            <Route path="/glossary" element={<Glossary />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/trading-platforms" element={<TradingPlatforms />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
